var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { MovieBlockView } from "../../components/views/block/MovieBlockView";
import { getMovieBlocks, getContinueWatchingList, } from "../../services/movie.service";
import { useAuth } from "../../context/Auth";
import "./homeScreenStyles.css";
import "../../styles/general.css";
import { useRouter } from "../../context/Router";
import { ContinueWatchingBlockView } from "../../components/views/block/ContinueWatchingBlockView";
import { onMoviePress } from "../../utils/Helpers";
import { focusManager } from "../../utils/Focus";
import { ScrollToTopButton } from "../../components/views/buttons/ScrollToTopButton";
import { useTVScroll, isWithinPosterWindow } from "../../hooks/useTVScroll";
import { WelcomeOverlay } from "../../components/views/welcome-overlay/WelcomeOverlay";
import { useApp } from "../../context/App";
import { FooterView } from "../../components/views/footer/FooterView";
import { SkeletonContentLayout } from "../../components/views/SkeletonContentLayout";
import { useModalContext } from "../../context/ModalContext";
import { useExitModal } from "../../context/ExitModalContext";
var DOUBLE_BACK_WINDOW_MS = 1500;
export var HomeScreen = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var navigate = useRouter().navigate;
    var profile = useAuth().profile;
    var _b = useState([]), continueWatchingBlock = _b[0], setContinueWatchingBlock = _b[1];
    var _c = useState([]), movieBlocks = _c[0], setMovieBlocks = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(0), totalBlocksCount = _e[0], setTotalBlocksCount = _e[1];
    var _f = useState([]), loadedBlocks = _f[0], setLoadedBlocks = _f[1];
    var loadedBlocksRef = useRef(loadedBlocks);
    loadedBlocksRef.current = loadedBlocks;
    var verticalRef = useRef(null);
    var _g = useApp(), welcomeShown = _g.welcomeShown, dispatch = _g.dispatch;
    var _h = useState(!welcomeShown), showWelcome = _h[0], setShowWelcome = _h[1];
    var _j = useState(0), offset = _j[0], setOffset = _j[1];
    var showModal = useModalContext().showModal;
    var _k = useExitModal(), openExitModal = _k.openExitModal, isExitModalOpen = _k.isExitModalOpen, otherModalOpen = _k.otherModalOpen;
    var lastBackAtRef = useRef(0);
    useEffect(function () {
        var handleKeyDown = function (e) {
            if (!focusManager.isKey(e.keyCode, "BACK"))
                return;
            if (isExitModalOpen())
                return;
            if (otherModalOpen()) {
                lastBackAtRef.current = 0;
                return;
            }
            var now = Date.now();
            if (now - lastBackAtRef.current <= DOUBLE_BACK_WINDOW_MS) {
                e.preventDefault();
                e.stopPropagation();
                lastBackAtRef.current = 0;
                openExitModal();
            }
            else {
                lastBackAtRef.current = now;
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [openExitModal, isExitModalOpen]);
    var blocksPerCall = 3;
    useEffect(function () {
        focusManager.manualFocus("main-navbar", 0);
    }, []);
    var loadNextBlock = useCallback(function () {
        setLoadedBlocks(function (prevLoaded) {
            if (prevLoaded.length < movieBlocks.length) {
                var nextBlock = movieBlocks[prevLoaded.length];
                var rowIndex = continueWatchingBlock.length > 0
                    ? prevLoaded.length + 3
                    : prevLoaded.length + 2;
                focusManager.registerGroup({
                    name: nextBlock.slug,
                    position: rowIndex + 10,
                    itemHeight: 530,
                    verticalContainer: verticalRef.current,
                });
                return __spreadArrays(prevLoaded, [nextBlock]);
            }
            return prevLoaded;
        });
    }, [movieBlocks, continueWatchingBlock.length]);
    var fetchBlocks = useCallback(function (overrideOffset) { return __awaiter(void 0, void 0, void 0, function () {
        var currentOffset, res, newItems_1, registerBlock_1, baseIndex_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    currentOffset = overrideOffset !== null && overrideOffset !== void 0 ? overrideOffset : offset;
                    return [4 /*yield*/, getMovieBlocks({
                            lang: i18n.language,
                            limit: blocksPerCall,
                            offset: currentOffset,
                        })];
                case 2:
                    res = _a.sent();
                    setTotalBlocksCount(res.count);
                    newItems_1 = res.items || [];
                    if (newItems_1.length) {
                        setMovieBlocks(function (prev) { return __spreadArrays(prev, newItems_1); });
                        setOffset(function (prev) { return prev + blocksPerCall; });
                        if (currentOffset === 0 && !welcomeShown) {
                            setTimeout(function () {
                                setShowWelcome(false);
                                dispatch({
                                    type: "SET_WELCOME_SHOWN",
                                    welcomeShown: true,
                                });
                            }, 3000);
                        }
                        registerBlock_1 = function (block, rowIndex) {
                            focusManager.registerGroup({
                                name: block.slug,
                                position: rowIndex + 10,
                                itemHeight: 530,
                                verticalContainer: verticalRef.current,
                                resetIndexOnVerticalMove: true,
                            });
                        };
                        if (currentOffset === 0) {
                            newItems_1.forEach(function (block, i) {
                                var rowIndex = continueWatchingBlock.length > 0 ? i + 3 : i + 2;
                                registerBlock_1(block, rowIndex);
                            });
                            setLoadedBlocks(newItems_1);
                        }
                        else {
                            baseIndex_1 = loadedBlocksRef.current.length;
                            newItems_1.forEach(function (block, i) {
                                var rowIndex = continueWatchingBlock.length > 0
                                    ? baseIndex_1 + i + 3
                                    : baseIndex_1 + i + 2;
                                registerBlock_1(block, rowIndex);
                            });
                            setLoadedBlocks(function (prev) { return __spreadArrays(prev, newItems_1); });
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        blocksPerCall,
        i18n.language,
        continueWatchingBlock.length,
        isLoading,
        welcomeShown,
        dispatch,
        offset,
    ]);
    useEffect(function () {
        // Reset on language change
        setMovieBlocks([]);
        setLoadedBlocks([]);
        setOffset(0);
        fetchBlocks(0);
    }, [i18n.language]);
    var onEndReached = useCallback(function () {
        if (loadedBlocks.length < movieBlocks.length) {
            loadNextBlock();
        }
        else if (!isLoading && movieBlocks.length < totalBlocksCount) {
            fetchBlocks();
        }
    }, [
        loadedBlocks.length,
        movieBlocks.length,
        totalBlocksCount,
        isLoading,
        loadNextBlock,
        fetchBlocks,
    ]);
    var _l = useTVScroll({ onEndReached: onEndReached }), scrollToTopVisible = _l.scrollToTopVisible, focusedGroup = _l.focusedGroup;
    var focusedBlockIndex = useMemo(function () {
        if (!focusedGroup)
            return 0;
        var idx = loadedBlocks.findIndex(function (b) { return b.slug === focusedGroup; });
        return idx >= 0 ? idx : 0;
    }, [focusedGroup, loadedBlocks]);
    useEffect(function () {
        if (!(profile === null || profile === void 0 ? void 0 : profile.id) || !i18n.language)
            return;
        getContinueWatchingList({ lang: i18n.language }).then(function (res) {
            setContinueWatchingBlock(res);
            if (res.length > 0) {
                focusManager.registerGroup({
                    name: "continueWatchingBlock",
                    position: 2,
                    itemHeight: 330,
                    verticalContainer: verticalRef.current,
                });
            }
        });
    }, [i18n.language, profile === null || profile === void 0 ? void 0 : profile.id]);
    var handleMoviePress = useCallback(function (movie) {
        var result = onMoviePress(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var renderedBlocks = useMemo(function () {
        var hasContinueWatching = continueWatchingBlock.length > 0;
        return (React.createElement(React.Fragment, null,
            hasContinueWatching && (React.createElement(ContinueWatchingBlockView, { title: t("layout.continue_watching"), continueWatchingBlock: continueWatchingBlock, onMoviePress: handleMoviePress })),
            loadedBlocks.map(function (block, index) { return (React.createElement(MovieBlockView, { key: block.id, slug: block.slug, title: block.title, movies: block.movies, block: block, active: isWithinPosterWindow(index, focusedBlockIndex), onMoviePress: handleMoviePress })); })));
    }, [
        loadedBlocks,
        continueWatchingBlock,
        t,
        handleMoviePress,
        focusedBlockIndex,
    ]);
    return (React.createElement(React.Fragment, null,
        showWelcome && React.createElement(WelcomeOverlay, null),
        React.createElement(Header, null),
        React.createElement("div", { className: "screen-container", ref: verticalRef },
            isLoading && movieBlocks.length === 0 ? (React.createElement(SkeletonContentLayout, { showTitle: true, skeletonCount: 6 })) : (React.createElement(React.Fragment, null, renderedBlocks)),
            loadedBlocks.length > 0 && React.createElement(FooterView, { simple: true })),
        scrollToTopVisible && React.createElement(ScrollToTopButton, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/HomeScreen/HomeScreen.tsx
// module id = 109
// module chunks = 1